/* tslint:disable */
//----------------------
// <auto-generated>
//     Generated with WebApiTSGenerator, using the NSwag toolchain
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosRequestConfig, AxiosPromise, CancelToken } from 'axios';
import { injectable, inject, optional } from '@servicetitan/react-ioc';
import { makeCodedException, makeContent } from 'utils';

export interface ICaptchaApi {
    getReCaptchaSiteKey(cancelToken?: CancelToken): AxiosPromise<string | null>;
}

@injectable()
export class CaptchaApi implements ICaptchaApi {
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@inject("baseUrl") @optional() baseUrl?: string) {
        this.baseUrl = baseUrl || "";
    }

    getReCaptchaSiteKey(cancelToken?: CancelToken): AxiosPromise<string | null> {
        let url_ = this.baseUrl + "/app/api/Auth/GetReCaptchaSiteKey";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            cancelToken,
            url: url_,
            method: "GET",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return makeCodedException(axios.request<string | null>(options_));
    }
}
